import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.154 7.686a.245.245 0 0 0-.25.242c0 .129.107.242.25.242a.245.245 0 0 0 .248-.242.245.245 0 0 0-.248-.242Zm-1.65.242c0-.912.744-1.642 1.65-1.642.905 0 1.648.73 1.648 1.642 0 .912-.743 1.642-1.648 1.642-.906 0-1.65-.73-1.65-1.642Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 4.5a.7.7 0 0 1 .7-.7h12.6a.7.7 0 0 1 .7.7v11a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7v-11Zm1.4.7v6.894a8.122 8.122 0 0 1 1.128-.673c1.021-.506 2.235-.879 3.51-1.077 2.138-.331 4.54-.185 6.562.736V5.2H4.4Zm11.2 7.451c-1.788-1.028-4.155-1.263-6.347-.923-1.152.178-2.226.512-3.102.947-.794.394-1.389.852-1.751 1.317v.808h11.2v-2.149Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
